<!--
 * @Author: Merlin
 * @Date: 2024-09-27 10:14:17
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-26 14:47:15
 * @Description: 
-->
<template>
    <component
        :is="topWrap"
        v-if="isNumberValid"
        v-bind="oAttribute"
    >
        <span class="balance px-[1px]">
            {{ sShowFirst }}
        </span>
        <template #content>
            <slot></slot>
            <div class="popper-content"
                v-if="!$slots.default"
            > 
                <CurrentCoin
                    v-if="coinName"
                    :name="coinName"
                    class="w-[18px] mr-1"
                />
                <CasinoWidgetColoredAmount
                    :colors="['', '#55657e']"
                    :amount="fValue2Use" 
                    :accuracy="8"
                ></CasinoWidgetColoredAmount>
            </div>
        </template>
    </component>
    <!-- ↓ 值为 null 时显示以下内容 -->
    <span
        v-else
        class="none-value"
    >
        -<!--这里有一个减号-->
    </span>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";

const props = defineProps({
    usePopper: {
        type: Boolean,
    },
    numberValue: {
        type: [Number, String, null], 
        required: true, 
    },
    offsetDistance: {
        type: String,
    },
    prefix: {
        type: String,
    },
    suffix: {
        type: String,
        default: '',
    },
    coinName: {
        type: String,
    },
    iTailLong:{
        type: Number,
        default: 2,
    },
});

const topWrap = computed(()=>{
    if (props.usePopper) return markRaw(Popper);
    return 'span';
});

const oAttribute= computed(()=>{
    if (!props.usePopper) return {};
    return {
        style: oPopperStyle,
        hover: true,
        arrow: true,
        placement: "top",
        offsetDistance: props.offsetDistance,
    };
});

// ↓ 判断入参有效性 
const isNumberValid = computed(()=>{
    const fNumber = Number(props.numberValue);
    const arr = [
        (props.numberValue || props.numberValue === 0),
        (fNumber >= 0 || fNumber <= 0), // 不要 NaN 
    ];
    const bResult = arr.every(Boolean); 
    return bResult;  
});

// ↓ 入参转为数值值 
const fValue2Use = computed(()=>{
    if (isNumberValid.value){
        return Number(props.numberValue);
    }
    return 0;
});

// ↓使用千位分隔符 
const sShowFirst = computed(()=>{
    // ↓ 四舍五不入
    const fFixed = Number(
        getFixed(fValue2Use.value, props.iTailLong)
    );
    const sResult = (
        (props.prefix || '')
        + number2LocaleString(fFixed, props.iTailLong)
        + (props.suffix || '') 
    );
    return sResult; 
});


</script>

<style scoped lang="scss">
.popper-content{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.none-value{
    font-size: 14px;
    font-weight: 600;
    color: var(--color_dark-shades-gray-40); 
}
</style>

